<div class="pre-landing">
  <div style="text-align: center; margin-top: 20px">
    <h2>{{ "not_found.title" | translate }}</h2>
    <p>{{ "not_found.message" | translate }}</p>
  </div>
</div>
